/**
 * Configuration Azure B2C
 * Configuration pour l'authentification Microsoft Azure B2C
 */

export const b2cConfig = {
  clientid: '95e5d18f-82ab-478d-9bff-6464e439ad87',
  b2cScopes: ['https://financieredelaciteBtoC.onmicrosoft.com/AssetModelAPI/asset.read'],
  signin: 'https://financieredelacitebtoc.b2clogin.com/financieredelaciteBtoC.onmicrosoft.com/B2C_1_SIGNIN_WWW',
  reset: 'https://financieredelacitebtoc.b2clogin.com/financieredelaciteBtoC.onmicrosoft.com/b2c_1_reset_www',
  authorityDomain: 'financieredelacitebtoc.b2clogin.com',
}

export default b2cConfig
